// Libraries
import React from 'react';
import {FAQPageJsonLd, NextSeo} from "next-seo";
import Head from "next/head";

// Components
import FaqUI from "../components/FaqUI";

// Constants & Utils
import {META_INFO} from "../constants/metaConstants";
import {allFAQs} from "../constants/faqConstants";

const faqMainEntity = [];
allFAQs?.forEach(item => {
    faqMainEntity.push({
        "questionName": item?.title,
        "acceptedAnswerText": item?.desc
    })
})


export default function Faq() {
    return (
        <>
            <Head>
                <meta content={META_INFO.FAQ_PAGE_TITLE} name="twitter:title"/>
                <meta content={META_INFO.FAQ_PAGE_URL} name="twitter:url"/>
            </Head>

            <NextSeo
                title={META_INFO.FAQ_PAGE_TITLE}
                canonical={META_INFO.FAQ_PAGE_URL}
                openGraph={{
                    title: META_INFO.FAQ_PAGE_TITLE,
                    url: META_INFO.FAQ_PAGE_URL
                }}
            />

            {/* FAQPage Schema Markup */}
            <FAQPageJsonLd
                mainEntity={faqMainEntity}
            />


            <FaqUI />
        </>
    );
}
